import { adminApiFetch } from './apiService';

export const merchantService = {
  // 更新訂單項目欄位設定
  updateOrderItemColumns: async (columns) => {
    const response = await adminApiFetch('merchants/update_order_item_columns', {
      method: 'PATCH',
      body: JSON.stringify({ columns })
    });
    return response.json();
  }
};

export default merchantService;
